import dayjs from 'dayjs';

import {
  CLICK_VIDEOS_ONLY_CHECKBOX,
  CLICK_SELECT_SPECIALITY_BUTTON,
  CLICK_VIEW_ALL_BUTTON,
  CLICK_VIEW_MORE_BUTTON,
  CLICK_SUBMIT_COMMENT_BUTTON,
  CLICK_SHARE,
  CLICK_RELATED_CONTENT,
  CLICK_SUBMIT_REPLY
} from '../constants/ActionType';

export const NOT_FOUND = 'NOT FOUND';
export const DEFAULT_ID = 0;

export const onOnlyVideosButtonClick = (page_name) => {
  return {
    type: CLICK_VIDEOS_ONLY_CHECKBOX,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    pageName: page_name
  };
};

export const onSelectSpecialityButtonClicked = (page_name, speciality_id, speciality_name) => {
  return {
    type: CLICK_SELECT_SPECIALITY_BUTTON,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    pageName: page_name,
    id: speciality_id,
    specialityName: speciality_name
  };
};

export const onViewAllButtonClicked = (page_name) => {
  return {
    type: CLICK_VIEW_ALL_BUTTON,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    pageName: page_name
  };
};

export const onViewMoreButtonClicked = (page_name) => {
  return {
    type: CLICK_VIEW_MORE_BUTTON,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    pageName: page_name
  };
};

export const onCommentSubmitButtonPress = (page_name, comment) => {
  return {
    type: CLICK_SUBMIT_COMMENT_BUTTON,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    pageName: page_name,
    comment: comment
  };
};
export const onReplyComment = (page_name, comment, parent_id) => {
  return {
    type: CLICK_SUBMIT_REPLY,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    pageName: page_name,
    comment: comment,
    parent_comment_id: parent_id
  };
};
export const onRelatedCLick = (id = DEFAULT_ID, type = NOT_FOUND) => {
  return {
    type: CLICK_RELATED_CONTENT,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    content_id: id,
    content_type: type
  };
};

export const onShareClick = (id = DEFAULT_ID, type = NOT_FOUND, link = NOT_FOUND) => {
  return {
    type: CLICK_SHARE,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    content_id: id,
    content_type: type,
    share_link: link
  };
};
